import { render, staticRenderFns } from "./CommissionDetails.vue?vue&type=template&id=4d954bec&scoped=true&"
import script from "./CommissionDetails.vue?vue&type=script&lang=js&"
export * from "./CommissionDetails.vue?vue&type=script&lang=js&"
import style0 from "./CommissionDetails.vue?vue&type=style&index=0&id=4d954bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d954bec",
  null
  
)

export default component.exports